import { useMutation } from '@tanstack/react-query';
import { Moment } from 'moment';
import { getDatesRange, getTimezone } from '@mgm/common/utils';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';
import { IntegrationsController } from '../../../../services/integrations.api';
import { TGetMgmReportRes } from '../../../../types/responses';
import { payrollActions } from '../../../../store/payroll/slice';
import { useError } from '../../../../hooks/useCommon';

type TGetExportData = {
  dates: [Moment, Moment],
  emails: Array<string>
};
export function useGetMgmReportAPI() {
  const { personnel } = useAppSelector(getAuthenticateUser);
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();

  const getMgmReportApi = (payload: TGetExportData) => {
    const { fromDate, toDate } = getDatesRange(payload?.dates);

    const data = {
      ...payload,
      from: fromDate,
      to: toDate,
      shopName: personnel.shopName,
      timezone: getTimezone(),
    };

    return IntegrationsController().getMgmReport<TGetMgmReportRes>(data);
  };

  return useMutation(getMgmReportApi, {
    onSuccess: (rsp, variables) => {
      if (rsp?.success && 'report' in rsp) {
        const reports = rsp.report.map((report, index) => ({
          ...report,
          id: index,
          isNew: true,
        }));
        dispatch(payrollActions.setMgmReportData(reports));
      } else if (rsp?.error && rsp.error?.response?.status) {
        handleReqError(rsp.error, variables);
      } else if ('msg' in rsp) {
        console.error(`ERROR! get mgm report failed! ${rsp.msg}`);
      }
    },
    onError: (error) => {
      console.error(`ERROR! get mgm report threw an Exception! ${error}`);
    },
  });
}
